<div class="immo-job-container mt-3 ml-auto mr-auto">
  <div class="filters-container">
    <mat-form-field
      class="mr-3"
      appearance="outline"
      [class.error]="noCompanySelected"
    >
      <input
        matInput
        type="text"
        placeholder="Bedrijven (alle)"
        [(ngModel)]="searchTerm"
        (ngModelChange)="onSearchTermChanged()"
        [matAutocomplete]="auto"
      />
      <mat-autocomplete
        #auto="matAutocomplete"
        requireSelection
        [displayWith]="displayCompanyFn"
        (optionSelected)="onSelectCompany($event.option.value)"
        (opened)="clearSearchTermAll()"
        (closed)="resetSearchTermAll()"
      >
        <mat-option [value]="allCompaniesOption">Alle bedrijven</mat-option>
        <ng-container *ngIf="!loadingCompanies; else loading">
          <mat-option
            *ngFor="let option of filteredCompanyOptions; trackBy: trackById"
            [value]="option"
          >
            {{ option.regularName }}
          </mat-option>
        </ng-container>
        <ng-template #loading>
          <div class="option option--loading">
            <mat-spinner color="primary" diameter="24"></mat-spinner>
          </div>
        </ng-template>
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field class="select-field mr-3" appearance="outline">
      <mat-select
        matInput
        placeholder="Jaar"
        [(ngModel)]="selectedYear"
        (ngModelChange)="previousYear = selectedYear - 1"
      >
        <mat-option *ngFor="let option of yearOptions" [value]="option">
          {{ option }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="select-field mr-3" appearance="outline">
      <mat-select
        matInput
        placeholder="Kortingsgroep (alle)"
        [(ngModel)]="selectedDiscountGroups"
        (ngModelChange)="onDiscountGroupSelectionChanged()"
        multiple
      >
        <mat-select-trigger>
          {{ getDiscountGroupDisplay() }}
        </mat-select-trigger>
        <div class="option option--all">
          <mat-checkbox
            [(ngModel)]="allDiscountGroupOptioinsSelected"
            (ngModelChange)="onDiscountGroupAllChanged()"
            >Alle kortingsgroepen</mat-checkbox
          >
        </div>
        <mat-option
          *ngFor="let option of discountGroupOptions"
          [value]="option"
        >
          {{ option }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="select-field mr-3" appearance="outline">
      <mat-select
        matInput
        placeholder="Plaatsings type"
        [(ngModel)]="selectedPlacementType"
        [compareWith]="compareOrdinalEnum"
      >
        <mat-option [value]="allPlacementOption"
          >Alle plaatsings types</mat-option
        >
        <mat-option
          *ngFor="let option of placementTypeOptions"
          [value]="option"
        >
          {{ option.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="select-field mr-3" appearance="outline">
      <mat-select
        matInput
        placeholder="Klantstatus"
        [(ngModel)]="selectedClientStatus"
      >
        <mat-option *ngFor="let option of clientStatusOptions" [value]="option">
          {{ option }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <button class="btn btn-accent" (click)="filterOverview()" mat-flat-button>
      Toon
    </button>
  </div>

  <div class="table-container">
    <ng-container *ngIf="loadingResults; else overviewTable">
      <mat-spinner></mat-spinner>
    </ng-container>
    <ng-template #overviewTable>
      <table mat-table [dataSource]="data" class="example-table">
        <ng-container matColumnDef="company">
          <th mat-header-cell *matHeaderCellDef>Klantnaam</th>
          <th></th>
          <td mat-cell *matCellDef="let row">{{ row.companyName }}</td>
        </ng-container>

        <ng-container matColumnDef="year">
          <th mat-header-cell *matHeaderCellDef class="text-center">Jaar</th>
          <th></th>
          <td mat-cell *matCellDef="let row" class="text-center">
            {{ selectedYear }}
          </td>
        </ng-container>

        <ng-container matColumnDef="discountGroup">
          <th mat-header-cell *matHeaderCellDef class="text-center">
            Kortingsgroep
          </th>
          <th></th>
          <td mat-cell *matCellDef="let row" class="text-center">
            {{ row.companyDiscountGroup }}
          </td>
        </ng-container>

        <ng-container matColumnDef="total">
          <th mat-header-cell *matHeaderCellDef class="text-center">
            Totaal aantal {{ selectedYear }}
          </th>
          <th></th>
          <td mat-cell *matCellDef="let row" class="text-center">
            {{ row.total }}
          </td>
        </ng-container>
        <ng-container matColumnDef="totalPreviousYear">
          <th mat-header-cell *matHeaderCellDef class="text-center">
            Totaal aantal {{ previousYear }}
          </th>
          <th></th>
          <td mat-cell *matCellDef="let row" class="text-center">
            {{ row.totalPreviousYear }}
          </td>
        </ng-container>
        <ng-container matColumnDef="lastOrderDate">
          <th mat-header-cell *matHeaderCellDef class="text-center">
            Datum laatste bestelling
          </th>
          <th></th>
          <td mat-cell *matCellDef="let row" class="text-center">
            {{ row.lastOrderDate | date : 'dd/MM/yyyy' }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </ng-template>
    <mat-paginator
      [length]="totalItems"
      [pageSizeOptions]="pageSizeOptions"
      [showFirstLastButtons]="true"
      (page)="getOverview()"
    ></mat-paginator>
  </div>
</div>
